import Image from "next/image";

import BlackPill from "@/components/getting-started/BlackPill";
import { CTAButton } from "@/shadcn/ui/button";
import { GROQButton } from "@/sanity/lib/definitions";
import { PortableTextBlock } from "sanity";
import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";

export default function Card({
  assetImg,
  imageOrder,
  texts,
  titleClasses,
  hideCTAonMobile,
  cardClass,
  ctaData,
}: {
  assetImg: any;
  imageOrder: number;
  texts: PortableTextBlock[];
  titleClasses: string;
  hideCTAonMobile?: boolean;
  cardClass?: string;
  ctaData: GROQButton;
}) {
  return (
    <div
      className={`${
        cardClass ? cardClass : ""
      } flex flex-col lg:flex-row justify-center items-center gap-[4rem]`}
    >
      <Image
        src={assetImg}
        alt="asset image"
        className={`
          lg:w-[55%] lg:max-w-[55%] lg:basis-3/5 ${
            imageOrder === 1 ? "lg:order-1" : "lg:order-2"
          }`}
      />

      <div
        className={`flex flex-col justify-center items-center lg:items-start gap-[2rem] basis-2/5 ${
          imageOrder === 1 ? "order-2" : "order-1"
        }`}
      >
        {texts && (
          <PortableText
            value={texts ?? []}
            components={customRichTextComponent({
              block: {
                h6: ({ children }) => (
                  <BlackPill
                    text={children as string}
                    className="py-[0.76rem] px-[2.76rem] text-[1.75rem] lg:text-[1.75rem]"
                  />
                ),
                h3: ({ children }) => (
                  <h3
                    className={`text-white text-center lg:text-left ${titleClasses}`}
                  >
                    {children}
                  </h3>
                ),
                normal: ({ children }) => (
                  <p className="text-white text-[2rem] font-[400] leading-[150%] opacity-60 text-center lg:text-left mb-0">
                    {children}
                  </p>
                ),
              },
              list: {
                bullet: ({ children }) => (
                  <>
                    <ul className="!list-disc list-inside ml-[1rem] mb-[1rem] hidden lg:block">
                      {children}
                    </ul>
                    <div className="lg:hidden w-full flex flex-col justify-center items-center mt-[1rem] mb-[0.5rem]">
                      <div className="w-full justify-center items-center gap-[1rem] mb-[1rem]">
                        <ul className="list-disc text-center list-inside grid grid-cols-2">
                          {children}
                        </ul>
                      </div>
                    </div>
                  </>
                ),
                number: ({ children }) => <ol className="">{children}</ol>,
              },
              listItem: {
                bullet: ({ children }) => (
                  <li className="text-white text-[2rem] font-[400] leading-[150%] opacity-60">
                    {children}
                  </li>
                ),
              },
            })}
          />
        )}

        <div className={hideCTAonMobile ? "hidden lg:block" : ""}>
          {ctaData && <CTAButton data={ctaData} />}
        </div>
      </div>
    </div>
  );
}
